// @ts-nocheck
import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { createMemoryHistory } from 'history'
import PrivateRoute from 'components/PrivateRouter'

import Auth from 'pages/Auth'
import Dashboard from 'pages/Dashboard'

export const Routes = () => {
  const history = createMemoryHistory()

  return (
    <BrowserRouter history={history}>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/dashboard/" />} />
        <Route path="/auth" render={(props) => <Auth {...props} />} />
        <PrivateRoute
          path="/dashboard"
          component={(props) => <Dashboard {...props} />}
        />
      </Switch>
    </BrowserRouter>
  )
}
